import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmStripe from '~/components/atoms/Global/MdmStripe.vue';
import SalesDecoration from './SalesDecoration.vue';
import NoveltyDecoration from './NoveltyDecoration.vue';
import SpecialEventDecoration from './SpecialEventDecoration.vue';
import TrendDecoration from './TrendDecoration.vue';
export default {
  name: 'StripesDecoration',
  components: {
    SalesDecoration: SalesDecoration,
    NoveltyDecoration: NoveltyDecoration,
    SpecialEventDecoration: SpecialEventDecoration,
    TrendDecoration: TrendDecoration,
    MdmStripe: MdmStripe
  },
  props: {
    sales: {
      type: Object,
      required: true
    },
    novelty: {
      type: Boolean,
      required: true
    },
    special: {
      type: Object,
      required: true
    },
    trends: {
      type: Object,
      required: true
    }
  },
  computed: {
    salesPredicate: function salesPredicate() {
      return this.sales && this.sales.sales_amount;
    },
    specialEventPredicate: function specialEventPredicate() {
      return Object.keys(this.special).length > 0;
    },
    trendPredicate: function trendPredicate() {
      return Object.keys(this.trends).length > 0;
    },
    firstStripe: function firstStripe() {
      var component = null;

      if (this.novelty) {
        component = 'NoveltyDecoration';
      }

      if (this.offerPredicate) {
        component = 'OfferDecoration';
      }

      if (this.salesPredicate) {
        component = 'SalesDecoration';
      }

      return component;
    },
    secondStripe: function secondStripe() {
      var component = null;

      if (this.trendPredicate) {
        component = 'TrendDecoration';
      }

      if (this.specialEventPredicate) {
        component = 'SpecialEventDecoration';
      }

      return component;
    }
  }
};